export default __webpack_public_path__ + "static/media/export.99839dc0.svg";